// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Multi-factor authentication configuration'"></sub-header>

  <div class="alert alert--danger" ng-if="!\$ctrl.canSeeMfa">
    'Update user mfa status' or 'Configure mfa' permission is required to view this page.
  </div>
  <form ng-if="\$ctrl.canSeeMfa">
    <div class="form-column">
      <form-section form-title="'Multi-factor authentication'">
        <form-section-field field-title="'Status'">
          <select
            class="full-width"
            ng-model="\$ctrl.user.mfaEnabled"
            ng-disabled="true"
            ng-options="o.value as o.label for o in [{ label: 'Disabled', value: false }, { label: 'Enabled', value: true }]">
          </select>
        </form-section-field>
        <div class="summary-actions">
          <button type="button"
                  ng-if="!\$ctrl.user.mfaEnabled"
                  ng-click="\$ctrl.enableMfa()"
                  class="btn btn-success"
                  command-access="UpdateUserMfaStatus">Enable
          </button>
          <button type="button"
                  ng-if="\$ctrl.canConfigureMfa && \$ctrl.user.mfaEnabled && !\$ctrl.authDetails.mfaConfigured"
                  ng-click="\$ctrl.configureMfa()"
                  class="btn btn-success"
                  command-access="ConfigureMfa">Configure MFA
          </button>
          <button type="button"
                  ng-if="\$ctrl.canConfigureMfa && \$ctrl.user.mfaEnabled && \$ctrl.authDetails.mfaConfigured"
                  ng-click="\$ctrl.configureMfa()"
                  class="btn btn-primary"
                  command-access="ConfigureMfa">Re-configure MFA
          </button>
          <button type="button"
                  ng-if="\$ctrl.user.mfaEnabled"
                  ng-click="\$ctrl.disableMfa()"
                  class="btn btn-danger"
                  command-access="UpdateUserMfaStatus">Disable
          </button>
        </div>
      </form-section>
    </div>

    <div class="clearfix"></div>
    <modal on-api-ready="\$ctrl.onMfaModalApiReady">
      <modal-header><h2>Configure your device</h2></modal-header>
      <modal-body>
        <mfa-configuration ng-if="!\$ctrl.mfaModalDeviceConfigured"
                           secret="\$ctrl.mfaConfigurationSecret"
                           organization-name="\$ctrl.mfaConfigurationOrganizationName"
                           username="\$ctrl.user.username"></mfa-configuration>
        <ng-form ng-if="\$ctrl.mfaModalDeviceConfigured" name="\$ctrl.mfaModalForm">
          <p>Please enter security code generated by the application, just to make sure everything is configured
            correctly.</p>
          <input
            type="text"
            pattern="\\d{6}"
            name="securityCode"
            ng-model="\$ctrl.mfaConfirmationSecurityCode"
            minlength="6"
            maxlength="6"
            required/>
          <div ng-if="\$ctrl.errorMessage">
            <span class="text-error">{{\$ctrl.errorMessage}}</span>
          </div>
        </ng-form>
      </modal-body>
      <modal-footer>
        <button type="button" class="btn" ng-click="\$ctrl.mfaModalApi.onCancel()">Cancel</button>
        <button type="submit" class="btn btn-success" ng-click="\$ctrl.mfaConfigurationNextStep()"
                ng-disabled="\$ctrl.mfaModalDeviceConfigured && !\$ctrl.mfaModalForm.\$valid">Next
        </button>
      </modal-footer>
    </modal>

  </form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.return()">
      Return
    </button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/mfa-configuration/mfa-configuration-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;